import { ModelBase } from "../base"

export class QuestionnaireModel extends ModelBase {
    id = 0;
    title = "";
    content = [
        new QuestionnaireContent()
    ]

    constructor(params) {
        super();
        this.mapModel(params);
    }
}

export class QuestionnaireCreateModel extends ModelBase {
    id = 0;
    title = "";

    constructor(params) {
        super();
        this.mapModel(params);
    }
}

export class QuestionnaireContent extends ModelBase {
    id = 0;
    questionnaireId = 0;
    languageId = 0;
    name = "";
    description = "";

    constructor(params) {
        super();
        this.mapModel(params);
    }
}